module.exports = __webpack_public_path__ + "static/media/home-slider-banner-2.a3f2f2e9.png";